import { createSlice, PayloadAction } from '@reduxjs/toolkit';
import {
  CoverageCatalog,
  CoverageCatalogResume,
  ProductConfiguration,
} from 'data-layer-cr/dist/models';
import { makeEmptyProductConfiguration } from 'data-layer-cr/dist/models/ProductConfiguration';

export type CoverageCatalogState = {
  coverageCatalogs: CoverageCatalog[];
  coverageCatalogResumes: CoverageCatalogResume[];
  productConfig: ProductConfiguration;
};

export const initialState: CoverageCatalogState = {
  coverageCatalogs: [],
  coverageCatalogResumes: [],
  productConfig: makeEmptyProductConfiguration(),
};

const coverageCatalogSlice = createSlice({
  name: 'coverageCatalog',
  initialState,
  reducers: {
    overwriteCoverageCatalog: (
      _,
      action: PayloadAction<CoverageCatalogState>,
    ): CoverageCatalogState => {
      return action.payload;
    },

    setCoverageCatalogs: (
      state,
      action: PayloadAction<CoverageCatalog[]>,
    ): void => {
      state.coverageCatalogs = action.payload;
      state.coverageCatalogResumes = action.payload.map(
        (covCatalog: CoverageCatalog): CoverageCatalogResume => ({
          code: covCatalog.code,
          type: covCatalog.type.code,
          applyDeductible: covCatalog.applyDeductible,
        }),
      );
    },

    setProductConfiguration: (
      state,
      action: PayloadAction<ProductConfiguration>,
    ): void => {
      state.productConfig = action.payload;
    },
  },
});

export const {
  overwriteCoverageCatalog,
  setCoverageCatalogs,
  setProductConfiguration,
} = coverageCatalogSlice.actions;

export default coverageCatalogSlice.reducer;
